import { render, staticRenderFns } from "./GlobalChunk.vue?vue&type=template&id=74c86b86&scoped=true"
import script from "./GlobalChunk.vue?vue&type=script&lang=js"
export * from "./GlobalChunk.vue?vue&type=script&lang=js"
import style0 from "./GlobalChunk.vue?vue&type=style&index=0&id=74c86b86&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c86b86",
  null
  
)

export default component.exports